export const environment = {
  production: false,
  apiUrl: 'https://ovofarmsapi.transgenie.io/api/v1',
};
